import { isEmpty } from 'lodash'
import { ICountry } from 'country-state-city/lib/interface'

import { requestIpAddress, TRequestGetGeoLocation } from 'utility-tools/module/location'

import { appConfigContext } from '../../../appServiceConfig'
import { TCountryDto, TFiscalLocationDto, TFiscalLocationValidationDto } from './models'
import { mapGeoLocationToFiscalLocation } from './mappers'

const getIsFiscalLocationLegal = ({
    country,
    state,
}: TFiscalLocationValidationDto | TFiscalLocationDto): boolean => {
    const prohibitedLocationDto =
        appConfigContext.getAppConfig().RESTRICTED_REGION_MAP[country.isoCode]

    const isCountryInRestrictedList = Boolean(prohibitedLocationDto)
    if (!isCountryInRestrictedList) return true

    const isEntireCountryRestricted = !prohibitedLocationDto.prohibitedStates
    if (isEntireCountryRestricted) return false

    return !prohibitedLocationDto.prohibitedStates.some(
        prohibitedState => prohibitedState.isoCode === state?.isoCode,
    )
}

const getIsCountryStateRequired = (countryDto: TCountryDto | ICountry): boolean => {
    if (countryDto) {
        const restrictedCountryDto =
            appConfigContext.getAppConfig().RESTRICTED_REGION_MAP[countryDto.isoCode]

        return !isEmpty(restrictedCountryDto?.prohibitedStates)
    }
    return false
}

const getIsFiscalLocationLegalByGeoLocationClientSide = async (
    requestGeoLocationNextApi: TRequestGetGeoLocation,
) => {
    // !!! USE IN CLIENT SIDE !!!
    const {
        data: { ip },
        error: ipAddressError,
    } = await requestIpAddress()
    if (ipAddressError) return false

    const { data: geoLocationDto, error: geoLocationError } = await requestGeoLocationNextApi(ip)
    if (geoLocationError) return false

    const fiscalLocation = mapGeoLocationToFiscalLocation(geoLocationDto)
    return getIsFiscalLocationLegal(fiscalLocation)
}

export {
    getIsFiscalLocationLegal,
    getIsCountryStateRequired,
    getIsFiscalLocationLegalByGeoLocationClientSide,
}
